export default "__VITE_ASSET__r$DwFqvV__"